import { render, staticRenderFns } from "./SurveyListView.vue?vue&type=template&id=070d04fb"
import script from "./SurveyListView.ts?vue&type=script&lang=ts&external"
export * from "./SurveyListView.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports